import stepsList from './modules/store'

export const modules = {
  stepsList
}



// WEBPACK FOOTER //
// ./src/store/Steps/index.js